import { observer } from 'mobx-react-lite'
import { uiStore } from 'shared/store/uiStore'
import { AccessLayout, ConversationRoutes } from 'entities/ExportRouters'
import { EnumAccessPageKeys } from 'entities/ExportRouters/lib/checkAccessPage'

export const ReviewsAccessLayout = observer(() => {
  return (
    <AccessLayout
      name={EnumAccessPageKeys.reviews}
      onAccessDenied={() => {
        uiStore.changeRouteViaVue({
          path: ConversationRoutes.root,
        })
      }}
    />
  )
})
